var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPovertyFall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 43,
    viewBox: "0 0 40 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    x: 0,
    y: 0,
    width: 40,
    height: 43
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H40V43H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.979 9.53257V9.53257C29.5638 9.53257 31.7174 7.43008 31.7174 4.72428C31.7174 2.08812 29.5638 0 26.979 0C24.3955 0 22.3218 2.08812 22.3218 4.72428C22.3218 7.43008 24.3955 9.53257 26.979 9.53257M35.4353 10.2334C37.2473 7.69648 41.3086 10.1489 39.5816 12.6032C36.1262 17.4955 31.2896 19.4303 26.2054 17.8459C24.5612 20.5656 23.0963 23.4538 21.6314 26.3416C23.7867 27.3937 26.2891 29.3965 27.5862 30.449C29.2171 31.7684 31.2896 37.0111 32.5888 39.5467C33.8889 42.448 29.5638 44.4547 28.2787 41.6631C27.1451 39.2947 25.3348 34.7389 24.2286 33.8696C23.1799 32.9864 19.6405 30.449 16.9733 29.4962C16.7948 29.3965 16.7111 29.3965 16.5459 29.312C13.2703 33.5209 6.78992 35.5241 1.27537 32.286C-1.6664 30.5335 1.01321 26.3416 3.94254 27.9957C8.00593 30.449 12.1371 27.3937 14.0435 23.5378C15.9379 19.6824 17.32 16.977 18.8668 14.2573C15.8547 13.304 13.0914 14.1728 10.9357 17.2434C9.20822 19.7664 5.07703 17.4106 6.78992 14.8737C11.0189 8.91575 17.32 7.43008 23.5241 11.2011C23.7867 11.3686 25.0022 11.9855 25.2515 12.1544C29.1334 14.5232 32.7553 14.0888 35.4353 10.2334",
    fill: "#EE4322"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPovertyFall);
export default __webpack_public_path__ + "static/media/icon-poverty-fall.0f456b3cb6c76a8f4b213714852f2816.svg";
export { ForwardRef as ReactComponent };